import ImgLogo from 'assets/img/logo/logo-page.png';
import React, { Component } from 'react';
import LoadingScreen from 'react-loading-screen';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withToastManager } from 'react-toast-notifications';
import { consumirServicioEncirptacion } from '../../api/index';
import SimpleToast from '../../components/Toasts/SimpleToas';
import {
  ambienteAplicacion,
  urlCatalogosCotizadorMex,
  urlResumenCotizadorMex,
} from '../../constants/urls';
import {
  FetchIdCotizacionActual,
  FetchIngresoInfCliente,
  FetchTarifacion,
} from '../../redux/actionsMex/aCarrito';
import { FetchCatalogoBtaEmpresas } from '../../redux/actionsMex/aCatalogos';

class ContainerHomeMex extends Component {
  async componentDidMount() {
    await this.onCargarCatalogos();
  }
  showToast(mensaje) {
    const { toastManager } = this.props;
    toastManager.add(<SimpleToast text={mensaje} />, {
      appearance: 'warning',
    });
  }

  onCargarCatalogos = async () => {
    //Consumir servicio de consulta de cotizacion
    const queryParams = new URLSearchParams(this.props.location.search);
    const id = queryParams.get('id');
    let datosEnviar = {
      datosCotizador: {
        prodCodigo: 'TRAVELBTA',
        idCotizacion: id,
      },
    };

    //Verifcar si el usuario esta logueado
    if (this.props.UsuarioDatos && this.props.UsuarioDatos.userIsLoggedIn === true) {
      datosEnviar = {
        ...datosEnviar,
        usuCotiza: { usuCodigo: this.props.UsuarioDatos.cliCodigoCore },
      };
    }

    console.log('DATA ENVIAR: ', datosEnviar);

    const data = await consumirServicioEncirptacion(
      urlCatalogosCotizadorMex,
      datosEnviar,
    );
    console.log('DATA: ', data);

    if (data.transaccion && data.transaccion === true) {
      if (data?.catalogo?.redireccionar === true) {
        await this.props.catalogoBtaEmpresas(data.catalogo);
        //Verificar si no es una recuperacion de datos

        if (id !== undefined && id !== '' && id !== null) {
          //SetearVariable Global de id de Cotizacion Actual
          let cotActual = { cotizador: 'TRAVELBTA', id: id };
          await this.props.setIdCotizacionActual(cotActual);
          // Recuperar información de la cotizacion
          await this.onRecuperarCarrito(id);
        }
      } else {
        this.showToast(data?.catalogo?.mensajeRedireccion);
        return this.props.history.push('/');
      }
    } else {
      this.showToast('Ha ocurrido un problema al recuperar la cotización');
      this.props.history.push('/');
    }
  };

  onRecuperarCarrito = async (id) => {
    //Recuperar toda la información del carrito servicio tarifacion

    let data = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: id,
      },
    };
    console.log('cotDatos', data);
    let dataT = await consumirServicioEncirptacion(urlResumenCotizadorMex, data);

    if (dataT.transaccion && dataT.transaccion === true) {
      let ArmarObjTarifacion = {
        planes: dataT.cotConsulta.prodDatos,
        valorTotal: dataT.cotConsulta.totGenerales,
        cotCodigo: id,
        cotUrl: dataT.cotConsulta.carUrlPdf,
      };

      await this.props.datosTarifacion(ArmarObjTarifacion);
      console.log('vvvv', dataT);
      //Verificar si se completo la informacion del contratante
      if (
        dataT.cotConsulta &&
        dataT.cotConsulta.carContratante &&
        dataT.cotConsulta.carContratante !== undefined &&
        dataT.cotConsulta.carContratante !== ''
      ) {
        this.props.setInformacionCliente(true);
      } else {
        this.props.setInformacionCliente(false);
      }

      //Redireccionar al resumen
      this.props.history.replace({
        pathname: `/travel-empresas-resumen`,
        search: `?id=${id}`,
      });
    } else {
      this.showToast('Ha ocurrido un error por favor intentar nuevamente.');
      //alert("Ha ocurrido un error por favor intentar nuevamente.");
    }
  };

  render() {
    return (
      <LoadingScreen
        loading={true}
        bgColor="#f1f1f1"
        spinnerColor="#9ee5f8"
        textColor="#676767"
        logoSrc={ImgLogo}
        text="Cargando..."
      ></LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  UsuarioDatos: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = (dispatch) => {
  return {
    catalogoBtaEmpresas: (datos) => dispatch(FetchCatalogoBtaEmpresas(datos)),
    datosTarifacion: (datos) => dispatch(FetchTarifacion(datos)),
    setIdCotizacionActual: (datos) => dispatch(FetchIdCotizacionActual(datos)),
    setInformacionCliente: (datos) => dispatch(FetchIngresoInfCliente(datos)),
  };
};

export default withToastManager(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ContainerHomeMex)),
);
